import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { DockProvider } from '../../context/DockContext';
import { useAuth } from '../../context/AuthContext';

const Layout = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const isAdmin = user?.role === 'admin';
  const isAdminRoute = isAdmin && location.pathname.startsWith('/admin');

  return (
    <DockProvider>
      <div className="bg-gray-50 w-full overflow-x-hidden">
        {isAdmin && <Header />}
        <main className={`w-full overflow-x-hidden ${isAdmin && !isAdminRoute ? 'pt-20' : ''}`}>
          {children}
        </main>
        <Footer />
      </div>
    </DockProvider>
  );
};

export default Layout;
